import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import "./login.css";
import "../../App.css";
import { requestRevoke } from "../../services/supporter";

const emailOk = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || "").trim());

// Passwordless "manage your support" (#2). The only reason a supporter logs in
// is to remove their support, so there's no password/session — enter your email,
// we send a one-click link, and the /revoke page confirms removal.
const LoginForm = (props) => {
  const { isOpen } = props;
  const close =
    props.toggleLoginVisibility || props.toggleVisibility || props.toggle || (() => {});
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setError("");
    if (!emailOk(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    const res = await requestRevoke(email.trim());
    setLoading(false);
    if (res.error) {
      setError(typeof res.error === "string" ? res.error : "Something went wrong. Please try again.");
      return;
    }
    setSent(true);
  };

  const onClose = () => {
    setSent(false);
    setError("");
    setEmail("");
    close();
  };

  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      toggle={onClose}
      centered
      modalClassName="login-wrapper"
      className="login-modal"
    >
      <ModalHeader toggle={onClose} cssModule={{ "modal-title": "w-100 text-center mb-0" }}>
        <div className="d-flex justify-content-center">
          <p style={{ textAlign: "center", marginBottom: 0 }}>MANAGE YOUR SUPPORT</p>
        </div>
      </ModalHeader>
      <ModalBody>
        {sent ? (
          <div style={{ textAlign: "center", padding: "6px 4px" }}>
            <div style={{ fontSize: 40, marginBottom: 6 }}>📬</div>
            <h5 style={{ color: "#5A8A8E" }}>Check your email</h5>
            <p style={{ margin: "8px 0 4px" }}>
              We sent a link to <strong>{email}</strong>. Click it to manage or remove your
              support.
            </p>
            <p style={{ fontSize: 13, color: "#6b7680" }}>
              It may land in your spam/junk folder. The link is good for 24 hours.
            </p>
            <Button color="secondary" size="sm" onClick={onClose} className="mt-2">
              Done
            </Button>
          </div>
        ) : (
          <Form onSubmit={submit}>
            <FormGroup className="mb-0">
              <Label for="login-email">Your email</Label>
              <Input
                type="email"
                name="email"
                id="login-email"
                value={email}
                placeholder="you@example.com"
                onChange={(e) => setEmail(e.target.value)}
              />
              <p style={{ fontSize: 13, color: "#6b7680", marginTop: 10 }}>
                Enter the email you signed up with. We'll email you a one-click link to
                manage or remove your support — no password needed.
              </p>
              {error && (
                <div style={{ color: "red", fontSize: 14, marginBottom: 8 }}>{error}</div>
              )}
              <Button type="submit" color="primary" size="sm" disabled={loading} onClick={submit}>
                {loading ? (
                  <>
                    <Spinner size="sm" color="light" className="mr-2" /> Sending…
                  </>
                ) : (
                  "Email me a link"
                )}
              </Button>
            </FormGroup>
          </Form>
        )}
      </ModalBody>
    </Modal>
  );
};

export default LoginForm;
